/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/utils/kitchenConfig.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-24 14:53:58
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-10 15:13:42
 */

export const SKIRTINGBOARDCONFIG = {
  HEIGHT: 0.08,
  DEPTH: 0.01,
};
export const CALLOUTMARGIN = 0.1;

export const TOPPANELCONFIG = {
  HEIGHT: 0.038,
  DEPTH: 0.035,
};
// 油烟机顶部距离场景顶部
export const VENTILATORTOPTOTOP = 0.40;

// TODO:高柜是220+支脚8
export const TOPTOGROUND = 2.28;

export const WALLHEIGH = 2.28;

export const TOPFRAME_GROUND = (templateJson) => {
  if ((templateJson?.bottom?.height === 70 && templateJson?.top?.height === 60)
  || (templateJson?.bottom?.height === 80 && templateJson?.top?.height === 60)) {
    return 2.1;
  }
  return 2.28;
};

// version2  无顶柜的时候默认给一个高度为60cm
export const DEFAULTTOPHEIGHT = 0.8;

export const TYPECODE = {
  DOORPLANK: (code) => code === '29125' || code === '11142' || code === '10935',
  DRAWER: (code) => code === '29957' || code === '11053',
  SIDEPLATEANDSEALPLATE: (code) => code === '31499',
};

export const DIRECTION = {
  HORIZAONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const HANDLEPOSITION = {
  FRAMEBOTTOMTOTOP: 0.02, // 底柜把手距离上部2cm
  FRAMETOPTOBOTTOM: 0.05, // 顶柜把手距离下部2cm
  FRAMETOPTOLEFT: 0.02, // 顶柜把手距离左部2cm
  DRAWERTOTOP: 0.02, // 抽屉把手距离上部2cm
};

export const HIGHFRAMERENDERVERSION = '2.1';

// 高柜门板组装渲染逻辑重写版本号
export const VERSION_2_1 = '2.1';

// 水槽跟水龙头位置不匹配提升版本号
export const VERSION_2_2 = '2.2';

export const FRAMEDEPTH = {
  BOTTOM: 0.6,
  TOP: 0.37,
  USBOTTOM: 0.4,
};

export const FRAMEDEPTH_U_S = {
  BOTTOM: 0.6,
  TOP: 0.4,
  U_S: 0.4,
};

export const FARMESPACE_U_S = 0.34;

// 沃拓普系列名字
export const VOXTORPGLOBALNAME = 'VOXTORP 沃托普';

export const FRAMECATEGORY = {
  /**
   * 两抽灶下柜
   */
  CATEGORY_1: 1,
  /**
   * 水槽空柜
   */
  CATEGORY_2: 2,
  /**
   * 普通柜体/底柜
   */
  CATEGORY_3: 3,
  /**
   * 普通柜体/顶柜
   */
  CATEGORY_4: 4,
  /**
   * 3抽抽屉柜
   */
  CATEGORY_5: 5,
  /**
   * 2抽抽屉柜
   */
  CATEGORY_6: 6,
  /**
   * 4抽抽屉柜
   */
  CATEGORY_7: 7,
  /**
   * 转角柜/底柜
   */
  CATEGORY_8: 8,

  /**
   * 转角柜/顶柜
   */
  CATEGORY_9: 9,
  /**
   * 高柜/全隔板3开门
   * https://www.ikea.cn/cn/zh/p/metod-mi-duo-gao-gui-dai-ge-ban-ge-men-bai-se-lei-er-xiu-tan-dan-hui-se-s09273270/
   */
  CATEGORY_10: 10,
  /**
   * 高柜/烤箱柜 (一个洞)   以下两行为一个连接
   * https://www.ikea.cn/cn/zh/p/metod-mi-duo-maximera-ma-si-mai-dian-kao-xiang
   * -zhuan-yong-gao-gui-dai-gui-men-ge-chou-ti-bai-se-shi-dan-sang-de-bai-se-s19410097/
   */
  CATEGORY_11: 11,
  /**
   * 高柜/微波炉和烤箱柜(两个洞)   以下两行为一个连接
   * https://www.ikea.cn/cn/zh/p/metod-mi-duo-maximera-ma-si-mai
   * -kao-wei-gao-gui-kuang-men-ti-bai-se-xi-na-pu-he-se-s69405102/
   */
  CATEGORY_12: 12,
  /**
   * 高柜，带清洁用品内配件 60
   */
  CATEGORY_33: 33,
  /**
   * 搁板高柜框/4屉/1门/2前板 60
   */
  CATEGORY_34: 34,
  /**
   * 高柜，带搁板/2个门 40
   */
  CATEGORY_35: 35,
  /**
   * 高柜，带清洁用品内配件 40
   */
  CATEGORY_36: 36,
  /**
   * 搁板高柜框/4屉/1门/2前板 40
   */
  CATEGORY_37: 37,
  /**
   * 调料抽
   */
  CATEGORY_13: 13,
  /**
   * 抽油烟机柜
   */
  CATEGORY_14: 14,
  /**
   * 水槽
   */
  CATEGORY_26: 26,
  /**
   * 带水槽的转角柜 必带水槽的
   */
  CATEGORY_27: 27,
  /**
   * 灶台转角柜
   */
  CATEGORY_28: 28,
  /**
   * 窗户
   */
  CATEGORY_29: 29,
  /**
   * 冰箱
   */
  CATEGORY_39: 39,
};

// 边的名字
export const BOTTOMSIDENAME = ['length1', 'length2', 'length3'];
export const TOPSIDENAME = ['length1', 'length2', 'length3'];
export const FRAMESTYPE = {
  top: 'top',
  bottom: 'bottom',
};
// 默认补板宽度
export const DEFAULTSEALPLATEWIDTH = 60;
export const DEFAULTTOPSEALPLATEWIDTH = 37;
export const DEFAULTSEALPLATEDEPTH = 0.019;
export const DEFAULTSEALPLATEHEIGHT = 80;
// 水槽距离转角柜边缘的距离
export const CORNERDISTANCE = 0.05;

// 转角柜的整体z会多出来8cm  但是渲染门板以及的时候需要把这个8cm给去掉
export const CORNEROUTDISTANCE = 0.08;

// 转角柜z轴居中需要减去模型多出来的8cm/2
export const HALFCORNEROUTDISTANCE = 0.04;

export const CORNERTYPE = {
  RIGTH: 'right',
  LEFT: 'left',
};

export const MINIMUM_WALL_WIDTH = 3;

export const MINIMUM_LTYPE_L1 = 2;

export const MINIMU_CAMERA_DISTANCE = 2;

export const AISLE_WIDTH = 1.2; // H型柜子的过道宽度
// version 2.0 add by zhanyu.shen 20211229
// 当顶柜长度-底柜长度-顶柜里高柜总长 > 20 时，高柜不与底柜相连，需要给高柜新建三块踢脚板
export const TOPHIGHTFRAMESEPARATEDLENGTH = 20;
// 顶柜特殊皮把手componentid
export const TOP_SPECIAL_LEATHER_HANDLE_ID = 170;

// 墙与柜子不穿模的最小间隙
export const GAP_BETWEEN_WALL_AND_CABINET = 0.005;
// version2.2 无孔水槽距离台面边缘的距离
export const DISTANCE_FROM_SINK_TO_EDGE = 0.05;
// 无孔水槽的水龙头距离柜体后壁的距离
export const DISTANCE_FROM_FAUCET_TO_WALL = 0.065;
// 有孔水槽距离柜体后壁的距离
export const DISTANCE_FROM_HOLESINK_TO_WALL = 0.025;
// 有孔水槽 水槽边缘距离孔的距离
export const DISTANCE_FROM_SINKEDGE_TO_SINKHOLE = 0.035;
// 水龙头开关在右边的时候需要偏移一部分  初步设定为3cm
export const DISTANCE_FAUCET_MOVE = 0.03;

// 侧板厚度在处理顶柜高柜阴影的时候会有一点点偏移所以要移动一下
export const SIDE_PLATE_THINKNESS = 0.02;

// 圆角水槽裁剪所需要的尺寸
export const ROUND_SINK_DISTANCE = 0.1;

// 单开门冰箱为55  占据60 所以每边的间距为0.25
export const SINGLE_DOOR_REFIRGERATOR_DISTANCE = 0.025;

// 双开门冰箱为90  占据100 所以每边的间距为0.5
export const DOUBLE_DOOR_REFIRGERATOR_DISTANCE = 0.05;

// 正方形转角柜的变长
export const SQUARE_CORNER_CABINET_SIDE_LENGTH = 88;

export const CORNER_CABINET_DEPTH = 68;

// 高低水槽柜比低柜高的高度
export const HIGHTLOW_SINKCABINET_HEIGHT = 0.1;

export const FRAME_HEIGHT = {
  HIGH: 0.8,
  LOW: 0.7,
};

